import {
  faCloud,
  faNetworkWired,
  faCode,
  faWifi,
  faSatelliteDish,
  faLayerGroup,
  faShieldHalved,
} from "@fortawesome/free-solid-svg-icons";

export const JOBS = [
  {
    jobDate: "timeline.jobSecOps.jobDate",
    title: "timeline.jobSecOps.title",
    company: "timeline.jobSecOps.company",
    jobDescription: "timeline.jobSecOps.jobDescription",
    sectionsKey: "timeline.jobSecOps.sections",
    durationLabel: "présent",
    tags: ["DevSecOps", "GCP", "Azure", "Cloudflare", "Terraform", "Ansible", "K8s", "Helm", "GitLab CI", "Fortinet", "Stormshield", "Proxmox", "SentinelOne", "Sekoia"],
    icon: faShieldHalved,
    url: "https://www.eurecia.com/",
  },
  {
    jobDate: "timeline.job0.jobDate",
    title: "timeline.job0.title",
    company: "timeline.job0.company",
    jobDescription: "timeline.job0.jobDescription",
    sectionsKey: "timeline.job0.sections",
    durationLabel: "10 mois",
    tags: ["GCP", "Azure", "Cloudflare", "Terraform", "Ansible", "K8s", "Helm", "GitLab CI", "Fortinet", "Stormshield", "Proxmox", "SentinelOne"],
    icon: faLayerGroup,
    url: "https://www.eurecia.com/",
  },
  {
    jobDate: "timeline.job1.jobDate",
    title: "timeline.job1.title",
    company: "timeline.job1.company",
    jobDescription: "timeline.job1.jobDescription",
    sectionsKey: "timeline.job1.sections",
    durationLabel: "2 ans 5 mois",
    tags: ["Azure", "GCP", "Terraform", "Kubernetes", "Helm", "Zabbix", "GitLab CI"],
    icon: faCloud,
    url: "https://obiz-concept.fr/",
  },
  {
    jobDate: "timeline.job2.jobDate",
    title: "timeline.job2.title",
    company: "timeline.job2.company",
    jobDescription: "timeline.job2.jobDescription",
    sectionsKey: "timeline.job2.sections",
    durationLabel: "1 an 2 mois",
    tags: ["Linux", "VMware", "OpenVPN", "Zabbix", "Active Directory"],
    icon: faNetworkWired,
    url: "https://adelya.com/",
  },
  {
    jobDate: "timeline.job3.jobDate",
    title: "timeline.job3.title",
    company: "timeline.job3.company",
    jobDescription: "timeline.job3.jobDescription",
    sectionsKey: "timeline.job3.sections",
    durationLabel: "5 mois · Stage",
    tags: ["Raspberry Pi", "Python", "IoT", "InfluxDB"],
    icon: faCode,
    url: "https://crestic.univ-reims.fr/",
  },
  {
    jobDate: "timeline.job4.jobDate",
    title: "timeline.job4.title",
    company: "timeline.job4.company",
    jobDescription: "timeline.job4.jobDescription",
    sectionsKey: "timeline.job4.sections",
    durationLabel: "2 ans 2 mois",
    tags: ["Wi-Fi", "Android", "Matériel", "Logistique"],
    icon: faWifi,
    url: "https://www.ivalis-dom.fr/",
  },
  {
    jobDate: "timeline.job5.jobDate",
    title: "timeline.job5.title",
    company: "timeline.job5.company",
    jobDescription: "timeline.job5.jobDescription",
    sectionsKey: "timeline.job5.sections",
    durationLabel: "1 an · Stage",
    tags: ["Cisco", "Transmission", "Télécom", "Maintenance"],
    icon: faSatelliteDish,
    url: "https://www.asecna.aero/index.php/fr/",
  },
];
